import { Injectable, Injector } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { AbstractRepositoryV2 } from 'src/app/modules/core/service/v2/abstractRepositoryV2';
import { MedicalToolSetModel } from '../../../api/entity/medicalToolSet.model';

@Injectable({
    providedIn: 'root'
})
export class MedicalToolSetRepository extends AbstractRepositoryV2<MedicalToolSetModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('MedicalToolSet', serviceElementsFactory, injector);
    }
}

